<cm-base-error-page [config]="config" />
